import { render, staticRenderFns } from "./HelpCard.vue?vue&type=template&id=4cf88dcc&scoped=true&"
import script from "./HelpCard.vue?vue&type=script&lang=ts&"
export * from "./HelpCard.vue?vue&type=script&lang=ts&"
import style0 from "./HelpCard.vue?vue&type=style&index=0&id=4cf88dcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf88dcc",
  null
  
)

export default component.exports